import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const Button = ({
  text,
  icon = null,
  iconPosition = "before",
  textDecoration = false,
  className = "",
  to = "",
  onClick,
  ...props
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      className={`btn ${className}`}
      onClick={handleClick}
      {...props}
      style={{
        border: "1px solid white",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        textDecoration: textDecoration ? "underline" : "none",
        display: "inline-flex",
        alignItems: "center",
        gap: icon ? "0.5rem" : "0",
        padding: "0.5rem 1rem",
        borderRadius: "0.25rem",
        color:"white",
      }}
    >
      {icon && iconPosition === "before" && <span className="btn-icon">{icon}</span>}
      {text}
      {icon && iconPosition === "after" && <span className="btn-icon">{icon}</span>}
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  iconPosition: PropTypes.oneOf(["before", "after"]),
  textDecoration: PropTypes.bool,
  className: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
};

export default Button;
